import {
  ArrowRight,
  BarChart3,
  Settings,
  Users,
  CreditCard,
  FileText,
  Lock,
  Calendar,
} from "lucide-react";
import { Link } from "react-router-dom";
import pricing from "./../assets/pricing.png";

export default function DashboardSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-green-100 text-blue-800 mb-6">
            <BarChart3 className="w-4 h-4 mr-2" />
            <span className="text-sm font-medium">Zentrale Steuerung</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Umfassendes Dashboard für Kommunen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Behalten Sie den Überblick über alle BikeParking-Anlagen in Ihrer
            Stadt mit unserem leistungsstarken Dashboard
          </p>
        </div>

        {/* Dashboard Preview */}
        <div className="relative mb-16">
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-gradient-to-br from-blue-300 to-green-300 rounded-full opacity-30 blur-3xl"></div>
          <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-gradient-to-br from-blue-300 to-green-300 rounded-full opacity-30 blur-3xl"></div>

          <div className="relative z-10 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
            <div className="bg-gradient-to-r from-blue-600 to-green-600 h-2"></div>
            <div className="p-4">
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Dashboard-1xFtS7BWTFI8LDpFcZsAzAVFE6dv5t.png"
                alt="JUHUU Dashboard für Kommunen"
                width={1000}
                height={500}
                className="rounded-lg w-full"
              />
            </div>
          </div>
        </div>

        {/* Dashboard Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
            <div className="h-12 w-12 mb-4 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
              <Settings className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Gerätemanagement
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Umfassende Verwaltung aller BikeParking-Geräte und -Anlagen
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-blue-600 mr-2"></div>
                <span>Hinzufügen, Entfernen, Sperren von Geräten</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-blue-600 mr-2"></div>
                <span>Übersicht über Auslastungen und Gerätestatus</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-blue-600 mr-2"></div>
                <span>Fernöffnung und Wartungsmodus</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
            <div className="h-12 w-12 mb-4 rounded-lg bg-gradient-to-r from-green-500 to-green-600 flex items-center justify-center">
              <FileText className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Billing
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Vollautomatisierte Abrechnung und Zahlungsabwicklung
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-green-600 mr-2"></div>
                <span>Automatische Rechnungslegung an Nutzer</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-green-600 mr-2"></div>
                <span>Automatische Auszahlungen an Betreiber</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-green-600 mr-2"></div>
                <span>Refunds, Kautionen und Gutschriften</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
            <div className="h-12 w-12 mb-4 rounded-lg bg-gradient-to-r from-purple-500 to-purple-600 flex items-center justify-center">
              <BarChart3 className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Datenanalyse
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Umfassende Statistiken und Berichte zur Nutzung und Auslastung
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-purple-600 mr-2"></div>
                <span>Exportfunktion (CSV, PDF, Excel)</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-purple-600 mr-2"></div>
                <span>Auslastungs- und Umsatzstatistiken</span>
              </li>
              <li className="flex items-center">
                <div className="h-1.5 w-1.5 rounded-full bg-purple-600 mr-2"></div>
                <span>Nutzerverhalten und Trends</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Flexible Tarifsysteme */}
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 md:p-12 shadow-lg mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-green-100 text-blue-800 mb-6">
                <CreditCard className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">
                  Flexible Tarifsysteme
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Maßgeschneiderte Preismodelle
              </h3>
              <p className="text-gray-600 mb-6">
                Wir bieten sehr flexible Möglichkeiten für Tarife, die
                spezifisch jedem Standort hinzugefügt werden können. Von
                Pay-as-you-go über Tages-, Monats- und Jahrestarife ist alles
                frei einstellbar. Wir unterstützen auch die Integration von
                lokalen oder bundesweiten Vorteilskarten für vergünstigte
                Tarife.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Calendar className="h-5 w-5 text-blue-600 mr-2" />
                    <h4 className="font-medium text-gray-900">
                      Zeitbasierte Tarife
                    </h4>
                  </div>
                  <p className="text-sm text-gray-600">
                    Pay-as-you-go, Tages-, Monats-, Jahrestarife
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Users className="h-5 w-5 text-green-600 mr-2" />
                    <h4 className="font-medium text-gray-900">
                      Unternehmensaccounts
                    </h4>
                  </div>
                  <p className="text-sm text-gray-600">
                    Kontingente für Mitarbeiter mit zentraler Abrechnung
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Users className="h-5 w-5 text-purple-600 mr-2" />
                    <h4 className="font-medium text-gray-900">
                      Familienaccounts
                    </h4>
                  </div>
                  <p className="text-sm text-gray-600">
                    Gemeinsame Nutzung für Familienmitglieder
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Lock className="h-5 w-5 text-orange-600 mr-2" />
                    <h4 className="font-medium text-gray-900">
                      Vorteilskarten
                    </h4>
                  </div>
                  <p className="text-sm text-gray-600">
                    Integration lokaler und bundesweiter Rabattsysteme
                  </p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-blue-300 to-green-300 rounded-full opacity-30 blur-2xl"></div>
              <img
                src={pricing}
                alt="Flexible Tarifsysteme"
                width={400}
                height={300}
                className="rounded-lg relative z-10"
              />
              <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-blue-600 to-green-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium">
                Individuell anpassbar
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
